"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageBlob2array = exports.exceptionBlob2array = exports.exception2array = exports.exception2string = void 0;
/**
 * Shows an alert with the error information
 * @param error
 */
function exception2alert(error) {
    alert(exception2string(error));
}
exports.default = exception2alert;
function isString(value) {
    return typeof value === 'string' || value instanceof String;
}
/**
 * Transforms an error exception to a string
 * @param error
 * @param ignoreMsg
 */
function exception2string(error, ignoreMsg = false) {
    return exception2array(error).join('\n');
}
exports.exception2string = exception2string;
function exception2array(error) {
    var _a;
    // New version of Javi's code
    let errors = [];
    const axiosError = error;
    if (isString(error)) {
        errors.push(error);
    }
    else if (axiosError.isAxiosError !== undefined) {
        const data = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data;
        if (data) {
            // const errorMessage = data.message || data.error;
            let errorMessage = data.message;
            if (isString(data.error)) {
                errorMessage = data.message || data.error;
            }
            if (errorMessage) {
                errors.push(errorMessage);
            }
            if (data.errors) {
                errors = errors.concat(Object.keys(data.errors).map((key) => data.errors[key].join('\n')));
            }
        }
        else {
            errors.push(axiosError.message);
        }
    }
    else if (error instanceof Error) {
        errors.push(error.message);
    }
    return arrayUniqueValues(errors);
}
exports.exception2array = exception2array;
async function exceptionBlob2array(error) {
    let errors = [];
    let parsedError = JSON.parse(await error.response.data.text());
    if (parsedError.message) {
        errors.push(parsedError.message);
    }
    if (parsedError.errors) {
        errors = errors.concat(Object.values(parsedError.errors).flatMap((error) => error));
    }
    // Customized errors
    if (parsedError.error) {
        try {
            parsedError = JSON.parse(parsedError.error).error;
            if (parsedError) {
                errors = errors.concat(parsedError.errors.map((error) => error.message));
            }
        }
        catch (e) { }
    }
    return arrayUniqueValues(errors);
}
exports.exceptionBlob2array = exceptionBlob2array;
async function messageBlob2array(message) {
    return JSON.parse(await message.data.text());
}
exports.messageBlob2array = messageBlob2array;
function arrayUniqueValues(array) {
    return Array.from(new Set(array));
}
